module.exports = __webpack_public_path__ + "media/images/LED-icon-orange-557e112309397d665071543e1c2f2e90.svg";